import { JSX } from 'react'

import { IconProps } from '../../icon'

const Estrella: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_783_8)'>
      <path
        d='M16.0141 1L11.6341 10.8L1.4241 12.15L8.9341 19.55L6.9941 30.18L16.0141 24.96L25.0341 30.18L23.0941 19.55L30.6041 12.15L20.3941 10.8L16.0141 1Z'
        fill='#FFF042'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.0141 0C16.4085 0 16.7661 0.231856 16.9271 0.591961L21.0791 9.88187L30.7352 11.1586C31.1139 11.2087 31.431 11.4701 31.5523 11.8323C31.6736 12.1945 31.5781 12.5942 31.306 12.8623L24.1728 19.891L26.0179 30.0005C26.0879 30.384 25.9285 30.7733 25.6097 30.9977C25.2909 31.2222 24.8707 31.2408 24.5332 31.0455L16.0141 26.1154L7.49499 31.0455C7.15752 31.2408 6.73733 31.2222 6.41849 30.9977C6.09966 30.7733 5.94035 30.384 6.01035 30.0005L7.85536 19.891L0.72223 12.8623C0.450142 12.5942 0.354555 12.1945 0.475902 11.8323C0.59725 11.4701 0.914332 11.2087 1.29302 11.1586L10.9491 9.88187L15.1011 0.591961C15.2621 0.231856 15.6197 0 16.0141 0ZM16.0141 3.45075L12.5471 11.208C12.4054 11.525 12.1094 11.7459 11.7652 11.7914L3.58288 12.8733L9.63597 18.8377C9.87174 19.07 9.97728 19.4039 9.91785 19.7295L8.36642 28.2304L15.5132 24.0945C15.8231 23.9152 16.2051 23.9152 16.515 24.0945L23.6618 28.2304L22.1103 19.7295C22.0509 19.4039 22.1565 19.07 22.3922 18.8377L28.4453 12.8733L20.263 11.7914C19.9188 11.7459 19.6228 11.525 19.4811 11.208L16.0141 3.45075Z'
        fill='#FDC612'
      />
    </g>
    <defs>
      <clipPath id='clip0_783_8'>
        <rect
          width='31.18'
          height='31.18'
          fill='white'
          transform='translate(0.424103)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default Estrella
